import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-subscription-management',
  templateUrl: './subscription-management.component.html',
  styleUrls: ['./subscription-management.component.scss']
})
export class SubscriptionManagementComponent implements OnInit {

  constructor(private userService: UsersService, private toastrService: ToastrService) { }
  public selectedMenu: boolean = false;
  public isMenu: boolean = false;
  public usersDetails: any[] = [];
  public isUserInfoSelected: boolean = false;
  public selectedUser: any;
  public enrollFilter: string = 'All';
  public subscribedUsers:any = {};
  ngOnInit(): void {
    this.onGetSubscribedUsers();
  }

  onGetSubscribedUsers() {
    this.userService.getSubscribedUsers().subscribe((value:any)=>{
      this.subscribedUsers = value.usersByStatus;
      console.log(this.subscribedUsers);
    })
  }

  restrict(user) {
    // console.log(course);
    this.userService.restricUserSubscription(user._id).subscribe(
      (res: any) => {
        this.toastrService.success(`Subscription restricted successfully!`);
        this.onGetSubscribedUsers();
      }
    )
  }

  enable(user) {
    this.userService.enableUserSubscription(user._id, user.subscription.tenureInMonths).subscribe(
      (res: any) => {
        this.toastrService.success(`Subscription enabled successfully!`);
        this.onGetSubscribedUsers();
      }
    )
  }

  onChangeEnrollFilter(filter) {
    this.enrollFilter = filter;
  }

  onClickUserInfo(user) {
    this.selectedUser = user;
    this.isUserInfoSelected = true;
  }

  onCloseUserInfo(event) {
    if (event == 'close') {
      this.isUserInfoSelected = false;
      this.selectedUser = {};
    }
  }

}
